import Vue from 'vue'
import * as CONST from '@/constants'
import * as Maths from '@/helpers/Math.js'

Vue.mixin({
  data() {
    return {
      CONST: CONST.ALL_CONSTANTS,
      Num: Maths.Num,
    }
  },
  computed: {
    currency() {
      let currencies = this.$store.getters.get_currencies(
        this.$store.getters.selectedCountry
      )
      if (currencies) return currencies.short_name
      if (this.$store.getters.currentStore) {
        return this.$store.getters.currentStore.currency
      }
      return 'AED'
    },
  },
})
